module.exports = __webpack_public_path__ + "static/media/profile.a20baf66.png";